import * as ACTION from "../../../store/actions/actionTypes";
import { UpdateObject } from "../../../utils/utils";

const initialState = {
  loading: false,
  errorMsg: "",
  locationInfo: [],
};

const litLocationInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.LIT_GET_LOCATION_INFO_REQUEST:
      return UpdateObject(state, { loading: true });
    case ACTION.LIT_GET_LOCATION_INFO_SUCCESS:
      return UpdateObject(state, {
        loading: false,
        locationInfo: action.payload,
      });
    case ACTION.LIT_GET_LOCATION_INFO_FAILURE:
      return UpdateObject(state, {
        loading: false,
        errorMsg: action.payload,
      });
    default:
      return state;
  }
};

export default litLocationInfoReducer;
